module.exports = __webpack_public_path__ + "static/img/logo.25d05ef6.svg";